"use client"
import styled from 'styled-components';
import { MockBrowser, BrowserContent } from './primitives'

const COVERAGE_ASSETS = [
  {
    cls: 'EQUITIES', name: 'S&P 500', price: '5,847.87', chg: '+0.84%', pos: true,
    line: 'M0,30 L13,26 L26,24 L39,18 L52,20 L65,12 L78,14 L91,6 L104,8 L117,2',
    area: 'M0,30 L13,26 L26,24 L39,18 L52,20 L65,12 L78,14 L91,6 L104,8 L117,2 L117,40 L0,40 Z',
  },
  {
    cls: 'ETFs', name: 'Nasdaq 100', price: '503.21', chg: '+1.12%', pos: true,
    line: 'M0,32 L13,28 L26,22 L39,24 L52,14 L65,16 L78,8 L91,10 L104,4 L117,2',
    area: 'M0,32 L13,28 L26,22 L39,24 L52,14 L65,16 L78,8 L91,10 L104,4 L117,2 L117,40 L0,40 Z',
  },
  {
    cls: 'FOREX', name: 'EUR / USD', price: '1.0842', chg: '-0.23%', pos: false,
    line: 'M0,14 L13,16 L26,12 L39,18 L52,16 L65,20 L78,18 L91,24 L104,22 L117,28',
    area: 'M0,14 L13,16 L26,12 L39,18 L52,16 L65,20 L78,18 L91,24 L104,22 L117,28 L117,40 L0,40 Z',
  },
  {
    cls: 'FUTURES', name: 'Crude Oil', price: '78.42', chg: '+0.67%', pos: true,
    line: 'M0,26 L13,30 L26,20 L39,24 L52,16 L65,18 L78,10 L91,14 L104,6 L117,4',
    area: 'M0,26 L13,30 L26,20 L39,24 L52,16 L65,18 L78,10 L91,14 L104,6 L117,4 L117,40 L0,40 Z',
  },
  {
    cls: 'INDICES', name: 'FTSE 100', price: '8,284.5', chg: '-0.11%', pos: false,
    line: 'M0,16 L13,14 L26,18 L39,12 L52,16 L65,20 L78,14 L91,18 L104,22 L117,26',
    area: 'M0,16 L13,14 L26,18 L39,12 L52,16 L65,20 L78,14 L91,18 L104,22 L117,26 L117,40 L0,40 Z',
  },
  {
    cls: 'CRYPTO', name: 'Bitcoin', price: '67,420', chg: '+2.31%', pos: true,
    line: 'M0,36 L13,26 L26,32 L39,14 L52,22 L65,6 L78,16 L91,4 L104,10 L117,2',
    area: 'M0,36 L13,26 L26,32 L39,14 L52,22 L65,6 L78,16 L91,4 L104,10 L117,2 L117,40 L0,40 Z',
  },
  {
    cls: 'EQUITIES', name: 'Dow Jones', price: '42,863.45', chg: '+0.52%', pos: true,
    line: 'M0,28 L13,24 L26,26 L39,20 L52,22 L65,16 L78,18 L91,10 L104,12 L117,4',
    area: 'M0,28 L13,24 L26,26 L39,20 L52,22 L65,16 L78,18 L91,10 L104,12 L117,4 L117,40 L0,40 Z',
  },
  {
    cls: 'ETFs', name: 'Invesco QQQ', price: '502.18', chg: '+1.34%', pos: true,
    line: 'M0,34 L13,30 L26,24 L39,26 L52,18 L65,20 L78,12 L91,14 L104,8 L117,4',
    area: 'M0,34 L13,30 L26,24 L39,26 L52,18 L65,20 L78,12 L91,14 L104,8 L117,4 L117,40 L0,40 Z',
  },
  {
    cls: 'FOREX', name: 'GBP / USD', price: '1.2734', chg: '+0.18%', pos: true,
    line: 'M0,20 L13,18 L26,22 L39,16 L52,18 L65,14 L78,16 L91,10 L104,12 L117,8',
    area: 'M0,20 L13,18 L26,22 L39,16 L52,18 L65,14 L78,16 L91,10 L104,12 L117,8 L117,40 L0,40 Z',
  },
  {
    cls: 'FUTURES', name: 'Gold', price: '2,412.60', chg: '+0.29%', pos: true,
    line: 'M0,24 L13,28 L26,18 L39,22 L52,14 L65,16 L78,8 L91,12 L104,4 L117,6',
    area: 'M0,24 L13,28 L26,18 L39,22 L52,14 L65,16 L78,8 L91,12 L104,4 L117,6 L117,40 L0,40 Z',
  },
  {
    cls: 'INDICES', name: 'Nikkei 225', price: '39,912.8', chg: '-0.44%', pos: false,
    line: 'M0,10 L13,12 L26,8 L39,14 L52,12 L65,18 L78,16 L91,22 L104,20 L117,26',
    area: 'M0,10 L13,12 L26,8 L39,14 L52,12 L65,18 L78,16 L91,22 L104,20 L117,26 L117,40 L0,40 Z',
  },
  {
    cls: 'CRYPTO', name: 'Ethereum', price: '3,542.10', chg: '+3.87%', pos: true,
    line: 'M0,34 L13,24 L26,30 L39,12 L52,20 L65,4 L78,14 L91,2 L104,8 L117,2',
    area: 'M0,34 L13,24 L26,30 L39,12 L52,20 L65,4 L78,14 L91,2 L104,8 L117,2 L117,40 L0,40 Z',
  },
];

const CovHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
`;
const CovTitle = styled.div`
  font-size: 13px;
  font-weight: 600;
  color: #111;
`;
const CovMeta = styled.div`
  font-size: 10px;
  color: #aaa;
`;
const AssetGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1px;
  background: #ebebeb;
  border-radius: 10px;
  overflow: hidden;
`;
const AssetTile = styled.div`
  background: #fff;
  padding: 10px 11px 8px;

  @media (max-width: 968px) {
    padding: 8px 8px 6px;
  }
`;
const AssetClass = styled.div`
  font-size: 8px;
  font-weight: 700;
  letter-spacing: 0.1em;
  color: #bbb;
`;
const AssetName = styled.div`
  font-size: 12px;
  font-weight: 600;
  color: #111;
  margin: 3px 0 6px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  @media (max-width: 400px) {
    font-size: 10px;
  }
`;
const SparkSvg = styled.svg`
  width: 100%;
  height: 28px;
  display: block;
`;
const AssetFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 5px;

  @media (max-width: 400px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 1px;
  }
`;
const AssetPrice = styled.div`
  font-size: 10.5px;
  color: #333;
  font-variant-numeric: tabular-nums;

  @media (max-width: 400px) {
    font-size: 9px;
  }
`;
const AssetChg = styled.div`
  font-size: 10px;
  font-weight: 700;
  color: ${({ $pos }) => ($pos ? '#16a34a' : '#dc2626')};

  @media (max-width: 400px) {
    font-size: 9px;
  }
`;

export const CoverageVisual = () => (
  <MockBrowser $path={'/product_images/3.webp'}>
    <BrowserContent>
      <CovHeader>
        <CovTitle>Market Coverage</CovTitle>
        <CovMeta>6 asset classes · 50,000+ instruments</CovMeta>
      </CovHeader>
      <AssetGrid>
        {COVERAGE_ASSETS.map((a, i) => (
          <AssetTile key={`${a.cls}-${i}`}>
            <AssetClass>{a.cls}</AssetClass>
            <AssetName>{a.name}</AssetName>
            <SparkSvg viewBox="0 0 117 40" fill="none" xmlns="http://www.w3.org/2000/svg">
              <defs>
                <linearGradient id={`covgrad-${i}`} x1="0" y1="0" x2="0" y2="1">
                  <stop offset="0%"   stopColor={a.pos ? '#16a34a' : '#dc2626'} stopOpacity="0.15" />
                  <stop offset="100%" stopColor={a.pos ? '#16a34a' : '#dc2626'} stopOpacity="0"    />
                </linearGradient>
              </defs>
              <path d={a.area} fill={`url(#covgrad-${i})`} />
              <path d={a.line} stroke={a.pos ? '#16a34a' : '#dc2626'} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </SparkSvg>
            <AssetFooter>
              <AssetPrice>{a.price}</AssetPrice>
              <AssetChg $pos={a.pos}>{a.chg}</AssetChg>
            </AssetFooter>
          </AssetTile>
        ))}
      </AssetGrid>
    </BrowserContent>
  </MockBrowser>
);
